<template>
  <div class="main">
    <!-- <i @click="closeMap" class="el-icon-error close_icon"></i> -->
    <div id="mapView"></div>
	<div class="setting">
		<el-popover
		  placement="left-start"
		  width="150"
		  trigger="hover">
			<el-scrollbar style="height: 200px" ref="scrollbar">
				<div style="display: flex;align-items: center;margin-top: 10px;" v-for="(item, index) in layerInfo" :key="item.id" v-if="layerInfo.length>0">
					<el-checkbox v-model="item.isShow" @change="clickTackCheck($event,item)" style="width: 100%;">{{item.name}}</el-checkbox>
				</div>
				<div v-if="layerInfo.length==0" style="text-align: center;line-height: 200px;">
					暂无图层
				</div>
			</el-scrollbar>
		  <i class="iconfont icon-layer" slot="reference" style="font-size: 22px;background: #fff;padding: 3px;border-radius: 3px;"></i>
		</el-popover>
	</div>
  </div>
</template>

<script>
import mapObj from './map'
import { GetLayerInfoByUId } from '@/api/Map';
import Layer from '@/components/layerComponent/DTPVecLayer'
export default {
    data(){
        return{
            layerInfo: [],
            // 底图图层
            baseMapLayer: [],
            // 矢量图层
            vectorLayer: []
        }
    },
    mounted(){
        this.initMap()
    },
    methods:{
		clickTackCheck(e,row){
			this.controlConcealment(row,e)
		},
        closeMap(){
            this.$emit('close')
        },
        initMap(){
            let that = this
            let { menuData } = require('@/utils/menuData');
            let children = menuData.find(x => x.id == that.$store.state.activateMenu)
            let menu = children.children.find(x => x.url == that.$store.state.activateMenuUrl)
            // 根据id获取数据
            GetLayerInfoByUId(menu.id).then(res => {
                if(res.data.state == 1) {
                    this.layerInfo = res.data.data
                    // 根据类型，做分类
                    this.layerInfo.forEach(layer => {
                        if(layer.type == 1) {
                            this.baseMapLayer.push(layer)
                        }else {
                            this.vectorLayer.push(layer)
                        }
                    })
                    mapObj.initMap(this.baseMapLayer)
                    // mapObj.initMap(this.baseMapLayer)
                    // 排序
                    let sortData = this.vectorLayer.sort((a,b) => {return a.index - b.index})
                    let layerIds = []
                    sortData.forEach(element => {
                        if(element.layerId && element.isShow) {
                            layerIds.push({layerId: element.layerId, zIndex: element.index})
                        }
                    })
                    let falg = setInterval(function() {
                        if(map){
                            clearInterval(falg)
                            setTimeout(() => {
                            let layer = Layer.initLayer("https://lyapp.gispai.com/",JSON.parse(localStorage.getItem("user-token-gispai")),map)
                            layer.addVecLayer(layerIds, 'init')
                            // 设置数据图层数据为最上层
                            let gc = document.getElementById("mapView_gc")
                            if(gc) {
                                gc.style.zIndex = 99999
                            }
                            }, 1000);
                        }
                    },1000)
                }
            })
        },
        // 控制图层显隐
        controlConcealment(item, show) {
            if(item.type == 1) {
                // 底图
                let element = document.getElementById("mapView_" + item.id)
                element.style.display = show ? 'block' : 'none'
            }else {
                // 矢量图层
                let element = document.getElementsByClassName("gispaiLayer_" + item.layerId)
                if(element.length > 0) {
                    element[0].style.display = show ? 'block' : 'none'
                } else {
                    if(show) {
                        let layer = Layer.initLayer("https://lyapp.gispai.com/",JSON.parse(localStorage.getItem("user-token-gispai")),map)
                        layer.addVecLayer([{layerId: item.layerId, zIndex: item.index}])
                    }
                }
            }
        },
        computedExtent(pointList){
            let xmin, ymin, xmax, ymax = 0
            if(pointList.length == 1){
                xmin = JSON.parse(pointList[0].Point)[0]
                xmax = JSON.parse(pointList[0].Point)[0] + 0.000001
                ymin = JSON.parse(pointList[0].Point)[1]
                ymax = JSON.parse(pointList[0].Point)[1] + 0.000001
            }else{
                let X = []
                let Y = []
                
                pointList.forEach(element => {
                    X.push(JSON.parse(element.Point)[0]) 
                    Y.push(JSON.parse(element.Point)[1]) 
                });
                // 排序
                X.sort((x,y) => {
                    return x - y
                })
                // 排序
                Y.sort((x,y) => {
                    return x - y
                })
                xmin = X[0]
                ymin = Y[0]
                xmax = X[X.length - 1]
                ymax = Y[Y.length - 1]
            }
            return [xmin, ymin, xmax, ymax]
        }
    }

}
</script>

<style lang="less" scoped>
.main{
    position: relative;
    width: 100%;
    height: 100%;
    // border: 1px solid #ebebeb;
    // border-right: 0px solid #ebebeb;
    // border-left: 1px solid #ebebeb;
    // border-top: 1px solid #ebebeb;
    // border-bottom: 1px solid #ebebeb;
    // .close_icon{
    //     font-size: 35px;
    //     color: #F56C6C;
    //     position: absolute;
    //     right: 8px;
    //     top: 8px;
    //     z-index: 999;
    // }
    .close_icon:hover{
        color: red;
        cursor: pointer;
    }
    #mapView {
    position: absolute;
    top: 0px;
    bottom: 0px;
    overflow: hidden;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 100vh;
  }
  .setting {
  	position: absolute;
  	top: 10px;
  	right: 10px;
  	z-index: 99;
  	color:#409eff;
  	cursor: pointer;
  }
}
</style>